import { render, staticRenderFns } from "./load404.vue?vue&type=template&id=a52d106a&scoped=true&"
import script from "./load404.vue?vue&type=script&lang=js&"
export * from "./load404.vue?vue&type=script&lang=js&"
import style0 from "./load404.vue?vue&type=style&index=0&id=a52d106a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52d106a",
  null
  
)

export default component.exports